import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const PageStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <path
        d="M12.1338 6.5V1.75C12.1338 1.33594 11.7978 1.00025 11.3838 1H1.75C1.33579 1 1 1.33579 1 1.75V13.25C1 13.6642 1.33579 14 1.75 14H6.06641C6.34255 14 6.56641 14.2239 6.56641 14.5C6.56641 14.7761 6.34255 15 6.06641 15H1.75C0.783502 15 0 14.2165 0 13.25V1.75C1.28853e-07 0.783502 0.783502 0 1.75 0H11.3838C12.3501 0.000246317 13.1338 0.783654 13.1338 1.75V6.5C13.1338 6.77599 12.9097 6.99975 12.6338 7C12.3576 7 12.1338 6.77614 12.1338 6.5Z"
        fill="currentColor"
      />
      <path
        d="M9.83321 2.79999C10.1093 2.79999 10.3332 3.02385 10.3332 3.29999C10.3332 3.57613 10.1093 3.79999 9.83321 3.79999H3.3C3.02386 3.79999 2.8 3.57613 2.8 3.29999C2.8 3.02385 3.02386 2.79999 3.3 2.79999H9.83321Z"
        fill="currentColor"
      />
      <path
        d="M9.3 5.60001C9.57615 5.60001 9.8 5.82386 9.8 6.10001C9.8 6.37615 9.57615 6.60001 9.3 6.60001H3.3C3.02386 6.60001 2.8 6.37615 2.8 6.10001C2.8 5.82386 3.02386 5.60001 3.3 5.60001H9.3Z"
        fill="currentColor"
      />
      <path
        d="M5.70039 8.39999C5.97636 8.4002 6.20039 8.62398 6.20039 8.89999C6.20039 9.17601 5.97636 9.39978 5.70039 9.39999H3.3C3.02386 9.39999 2.8 9.17614 2.8 8.89999C2.8 8.62385 3.02386 8.39999 3.3 8.39999H5.70039Z"
        fill="currentColor"
      />
      <path
        d="M5.09981 11.2C5.37595 11.2 5.59981 11.4239 5.59981 11.7C5.59981 11.9762 5.37595 12.2 5.09981 12.2H3.3C3.02386 12.2 2.8 11.9762 2.8 11.7C2.8 11.4239 3.02386 11.2 3.3 11.2H5.09981Z"
        fill="currentColor"
      />
      <rect className={statusClassName} height="6" rx="3" stroke="none" width="6" x="9" y="9" />
    </svg>
  );
};
